export default __webpack_public_path__ + "static/media/onboardingBgMobile.d415df21.png";